import React, { useMemo } from 'react';

import { Column, Row, WebpImageWithFallback } from '@husslehq/ui-library';

import styles from '../../components/ResourceList/ResourceList.module.scss';

export type ResourceListProps = {
  resources: Array<{ icon: string; name: string; open?: boolean; has_cost?: boolean }>;
  title: string;
};

export const ResourceList: React.FC<ResourceListProps> = ({ resources, title }) => {
  const isAnyResourceClosed = useMemo(() => {
    return resources.find((resource) => resource.open === false) !== undefined;
  }, [resources]);

  const doesAnyResourceCostExtra = useMemo(() => {
    return resources.find((resource) => resource.has_cost === true) !== undefined;
  }, [resources]);

  const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX ?? '';

  return (
    <div className={styles['resources__wrapper']}>
      <h4 className={styles['resources__title']}>{title}</h4>
      <Row>
        <ul className={styles.resources}>
          {resources.map((item, idx) => (
            <Column as="li" key={`${title}_resources_item_${idx}`} xs="12" md="6">
              <div className={styles['resources__item']}>
                <span className={styles['resources__icon-container']}>
                  <WebpImageWithFallback
                    alt={item.name}
                    className={styles['resources__icon']}
                    src={`${assetPrefix}/img/resources/${item.icon}.svg`}
                  />
                </span>
                {item.name} {item.has_cost === true ? <sup>*</sup> : ''} {item.open === false ? <sup>**</sup> : ''}
              </div>
            </Column>
          ))}
        </ul>
      </Row>
      {doesAnyResourceCostExtra && <small className={styles['resources__legend']}>* Available at extra cost</small>}
      {isAnyResourceClosed && <small className={styles['resources__legend']}>** Currently unavailable</small>}
    </div>
  );
};
